import { Dialog, DialogProps, styled } from "@mui/material";

const StyledDialog = styled(Dialog)(() => ({
  ".MuiDialog-paper": {
    borderRadius: "1rem",
  },

  ".MuiDialogTitle-root": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.5rem 1.5rem",
  },

  ".MuiDialogContent-root": {
    padding: "1.5rem",
  },

  ".MuiDialogActions-root": {
    padding: "0.5rem 1rem",
  },
}));

const Modal = ({ children, open, onClose, ...rest }: DialogProps) => {
  return (
    <StyledDialog open={open} onClose={onClose} {...rest}>
      {children}
    </StyledDialog>
  );
};

export { Modal };
export default Modal;
